import React, { useCallback, useEffect, useMemo, useState } from "react";
import styles from "../../PagesStyles/AdminRepairEntry.module.css";
import AdminHeading from "../Heading/AdminHeading";
import AlertMessage from "Components/Other Functions/AlertMessage";
import { ClipLoader } from "react-spinners";
import ErrorModal from "Components/Other Functions/popup";
import { useNavigate, useParams } from "react-router-dom";
import { toPlainFields } from "Components/support/Allfields/fieldconverter";
import {
  PurchaseEntryFields,
  PurchaseEntryLooseDiamondNewFields,
  PurchaseEntryLooseStoneNewFields,
  PurchaseEntryNewFields,
  RepairEntryNewFields
} from "Components/support/Allfields/purchasefields";
import { useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { RiAddBoxFill } from "react-icons/ri";
import { IoMdRefresh } from "react-icons/io";
import { GoTrash } from "react-icons/go";
import { Icon } from "@iconify/react";
import Summary from "Components/AdminPurchaseEntryNew/Summary";
import SkuForm from "Components/AdminPurchaseEntryNew/SkuForm";
import SkuFormRepair from "Components/AdminPurchaseEntryNew/SkuFormRepair";
import { useMutation, useQuery } from "@tanstack/react-query";
import GetApiService from "Components/Api/getapiService";
import {
  DiamondFields,
  getAllPaymentMethod,
  getPurchaseEntryFormData,
  goldCategoryIds,
  HeadersForAllCategory,
  HeadersForStones,
  looseDiamondId,
  looseStoneId,
  purchaseEntryEditJSon,
  purchaseEntryJson,
  selectStyle,
  silverCategoryIds,
  StoneFields,
} from "utils/helpers";
import toast from "react-hot-toast";
import PaymentModeForm from "Components/AdminPurchaseEntryNew/PaymentModeForm";
import PaymentModeFormRepair from "Components/AdminPurchaseEntryNew/PaymentModeFormRepair";
import Select from "react-select";
import {
  a154,
  a155,
  a156,
  a166,
  a167,
  a194,
  a742,
} from "Components/Api/RootApiPath";
import StoneSummary from "Components/AdminPurchaseEntryNew/StoneSummary";
import DiamondSummary from "Components/AdminPurchaseEntryNew/DiamondSummary";
import PaymentsEntryTable from "Components/AdminPurchaseEntryNew/PaymentsEntryTable";
import PaymentsEntryTableRepair from "Components/AdminPurchaseEntryNew/PaymentEntryTableRepair";
import AmountSection from "Components/AdminPurchaseEntryNew/AmountSection";
import AmountSectionRepair from "Components/AdminPurchaseEntryNew/AmountSectionRepiar";
import { sendFormData } from "services/purchaseServices";
import { MdCheck } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { Check, Refresh } from "@mui/icons-material";
import Spinner from "Components/CommonComponents/Spinner";
import AdminBreadCrump from "../Heading/AdminBreadCrump";
import { fetchVendorTouncheList } from "services/Tounches";
import 
// generatePurchaseInvoice, 
{ GeneratePurchase } from "Components/Other Functions/GeneratePurchaseInvoice";
import { fetchCustomerTouncheList } from "services/Tounches";

const AdminRepairEntryNew = ({ editStatus, defaultValues }) => { 
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [errorMessage, setErrorMessage] = useState(null);
  const [active, setActive] = useState("AddNew");
  // const [renderSummary,setIsRenderSummary] = useState(false)
  const [messageToShow, setMessageToShow] = useState("");
  const [messageType, setMessageType] = useState("");
  const [showError, setShowError] = useState(false);
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [category, setCategory] = useState("");
  const [purchaseCreateLoading, setPurchaseCreateLoading] = useState(false);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const CompanyId = adminLoggedIn.CompanyId;
  const BranchId = adminLoggedIn.BranchId;
  const CounterId = adminLoggedIn.CounterId;
  const EmployeeId = adminLoggedIn.EmployeeId;
  const labelFormat = parseInt(adminLoggedIn.Clients.LabelFormat);
  const apiService = new GetApiService(clientCode);

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });

  const fetchData = async () => {
    try {
      const data = await apiService.fetchInvoiceCustomers();
      return data;
    } catch (e) {
      throw new Error("Failed to fetch vendors");
    }
  };
  const customerName = watch("customerName");

 


  const {
      data: customerList,
     
      refetch: RefetchCustomerList,
    } = useQuery({
      queryKey: ["getAllcustomerList"],
      queryFn: fetchData,
      refetchOnWindowFocus: false,
      // cacheTime: 1000 * 60 * 2,
      // staleTime: 1000 * 60 * 2,
    });

    
    const { data: CustomerTounchList, refetch: customerListRefetch } = useQuery({
      queryKey: ["getCustomerTounchList", clientCode],
      queryFn: fetchCustomerTouncheList,
      refetchOnWindowFocus: false,
      // cacheTime: 1000 * 60 * 2,
      // staleTime: 1000 * 60 * 2,
    });

  const fetchRDPurchaseList = async () => {
    try {
      const data = await apiService.fetchAllRDPurchaseList();
      return data;
    } catch (e) {
      throw new Error("Failed to fetch RD purchase list");
    }
  };

  const {
    data: vendorlist,
    isLoading,
    isError,
    refetch: vebdorListRefetch,
  } = useQuery({
    queryKey: ["vendorlist"],
    queryFn: fetchData,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  const {
    data: RDPurchaseList,
    isLoading: RDPurchaseListIsLoading,
    isError: RDPurchaseListIsError,
    refetch: RDPurchaseRefetch,
  } = useQuery({
    queryKey: ["getRDPurchaseList"],
    queryFn: fetchRDPurchaseList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    staleTime: 1000 * 60 * 2,
  });

  const {
    data: vendorTounchList,
    isLoading: vendorTounchListIsLoading,
    isError: vendorTounchIsError,
    refetch: vendorTounchRefetch,
  } = useQuery({
    queryKey: ["purchaseEntry/getVendorTounchList", clientCode],
    queryFn: fetchVendorTouncheList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });

  // const purchaseEntryCreateMutation = useMutation({
  //   mutationFn:({formdata,data})=>sendFormData({formData,data})
  // })

  const apifields = useMemo(
    () =>
      adminLoggedIn?.Modules?.filter(
        (module) => module?.PageName === "purchase_entry"
      ),
    [adminLoggedIn]
  );

  // Log the updated itemfields
  const localfields = useMemo(() => toPlainFields(RepairEntryNewFields), []);

  const looseStoneLocalFields = useMemo(
    () => toPlainFields(PurchaseEntryLooseStoneNewFields),
    []
  );
  const looseDiamonLocalFields = useMemo(
    () => toPlainFields(PurchaseEntryLooseDiamondNewFields),
    []
  );
  console.log(apifields)

  const apifieldsControls = useMemo(
    () => (apifields?.length && apifields[0]?.PageControls) || [],
    [apifields]
  );

  console.log(apifieldsControls)
  const [itemfields, setItemfields] = useState(() =>
    localfields.map((localField) => {
      const matchingApiField = apifieldsControls.find(
        (apiField) => apiField.key === localField.key
      );
      if (matchingApiField) {
        return {
          ...localField,
          label: matchingApiField.label,
          placeholder: matchingApiField.placeholder,
          priority: matchingApiField.priority,
          type: matchingApiField.type,
          visibility: matchingApiField.visibility,
          place: matchingApiField.place,
        };
      }
      return localField;
    })
  );


  console.log(itemfields);
  
  const [itemLooseDiamondfields, setItemLooseDiamondfields] = useState(() =>
    looseDiamonLocalFields.map((localField) => {
      const matchingApiField = apifieldsControls.find(
        (apiField) => apiField.key === localField.key
      );
      if (matchingApiField) {
        return {
          ...localField,
          label: matchingApiField.label,
          placeholder: matchingApiField.placeholder,
          priority: matchingApiField.priority,
          type: matchingApiField.type,
          visibility: matchingApiField.visibility,
          place: matchingApiField.place,
        };
      }
      return localField;
    })
  );
  const [itemLooseStonefields, setItemLooseStonefields] = useState(() =>
    looseStoneLocalFields.map((localField) => {
      const matchingApiField = apifieldsControls.find(
        (apiField) => apiField.key === localField.key
      );
      if (matchingApiField) {
        return {
          ...localField,
          label: matchingApiField.label,
          placeholder: matchingApiField.placeholder,
          priority: matchingApiField.priority,
          type: matchingApiField.type,
          visibility: matchingApiField.visibility,
          place: matchingApiField.place,
        };
      }
      return localField;
    })
  );
  const [fields, setFields] = useState([]);

  const [editValues, setEditValues] = useState();
  const [edit, setEdit] = useState(false);
  
  const specificField = watch("StockKeepingUnit");
  const skus = watch("skus");
  const LotNumber = watch("LotNumber");
  const paymentTypes = watch("paymentTypes");
  const inputPaymentMode = watch("inputPaymentMode");
  const VendorName = watch("VendorName");
  const FineGold = watch("FineGold");
  const invoiceNumber = watch("invoiceNumber");
  const TotalFineMetal = watch("TotalFineMetal");
  const gstCheckbox = watch("gstCheckbox");
  const additionalTaxCheckbox = watch("additionalTaxCheckbox");
  const CourierCharge = watch("CourierCharge");
  const TotalBillAmount = watch("TotalBillAmount");
  const TotalTaxableAmount = watch("TotalTaxableAmount");
  const TotalRODiscount = watch("TotalRODiscount");
  const AdvanceAmount = watch("advanceamount");
  const TotalPaidAmount = watch("TotalPaidAmount");
  const invoiceDate = watch("invoiceDate");
  const status = watch("status");


  useEffect(() => {
    if(!editStatus){
    if ( RDPurchaseList?.length) {
      setValue(
        "LotNumber",
        +RDPurchaseList[RDPurchaseList?.length - 1]?.LotNumber + 1
      );
    }else{
      setValue(
        "LotNumber",
        1
      );
    }
  }
  }, [RDPurchaseList, editStatus]);

  useEffect(() => {
    if (editStatus) {
      setIsSummaryOpen(true);
    }
  }, [editStatus]);

  useEffect(() => {
    if (invoiceNumber) {
      setValue("gstCheckbox", true);
    } else {
      setValue("gstCheckbox", false);
    }
  }, [invoiceNumber]);

//  useEffect(()=>{
//     if(TotalTaxableAmount > 5000000){
//       setValue("additionalTaxCheckbox",true)
//     }
//   },[TotalTaxableAmount])

  useEffect(() => {
    // if(TotalRODiscount){

    if (gstCheckbox && TotalTaxableAmount) {
      setValue(
        "TotalBillAmount",
        (
          +(TotalTaxableAmount || 0) * 0.03 +
          +(TotalTaxableAmount || 0) -
          +(TotalRODiscount || 0)
        )?.toFixed(3)
      );
      setValue("TotalGst", (+(TotalTaxableAmount || 0) * 0.03)?.toFixed(3));
    } else {
      setValue(
        "TotalBillAmount",
        (+(TotalTaxableAmount || 0) - +(TotalRODiscount || 0))?.toFixed(3)
      );
      setValue("TotalGst", "");
    }
    if(additionalTaxCheckbox && TotalTaxableAmount 
      // && +(TotalTaxableAmount || 0) > 5000000
    ){
      setValue(
        "TotalBillAmount",
        (
          (gstCheckbox ? (+TotalTaxableAmount * 0.03) : 0) +
          (+TotalTaxableAmount * 0.001) +
          +TotalTaxableAmount -
          +TotalRODiscount + 
          +(CourierCharge || 0)
        )?.toFixed(3)
      );
      setValue("additionalTax", (+TotalTaxableAmount * 0.001)?.toFixed(3));
    }else{
      setValue(
        "TotalBillAmount",
        (
          (gstCheckbox ? (+TotalTaxableAmount * 0.03) : 0) +
          +TotalTaxableAmount -
          +TotalRODiscount + 
          +(CourierCharge || 0)
        )?.toFixed(3)
      );
      setValue("additionalTax","")
    }
    // }
  }, [TotalTaxableAmount, gstCheckbox,additionalTaxCheckbox, TotalRODiscount,CourierCharge, skus]);

  useEffect(() => {
    if (category == looseDiamondId) {
      const updatedFields = itemLooseDiamondfields?.map((field) => {
        if (DiamondFields.includes(field.key)) {
          return {
            ...field,
            IsVisible: true,
          };
        } else {
          return {
            ...field,
            IsVisible: false,
          };
        }
      });
      setFields(updatedFields);
    } else if (category == looseStoneId) {
      const updatedFields = itemLooseStonefields?.map((field) => {
        if (StoneFields.includes(field.key)) {
          return {
            ...field,
            IsVisible: true,
          };
        } else {
          return {
            ...field,
            IsVisible: false,
          };
        }
      });
      setFields(updatedFields);
    } else {
      setFields(itemfields);
    }
    console.log(category)
  }, [category]);

  useEffect(() => {
    let paidMetal = 0;
    let advanceAmount = 0;
    let balanceMetal = 0;
    let paidAmount = 0;
    
    paymentTypes?.forEach((item) => {
      if ((item?.status == "paid" || item?.status == "received") && item?.mode == "Metal") {
        paidMetal += +(item?.MetalFinePaid || 0);
      }
      if (item?.status == "advance") {
        advanceAmount += +(item?.amount || 0);
      }
      if (
        item?.status == "paid" &&
        (item?.mode == "Cash" || item?.mode == "Metal to Cash" || item?.mode == "Card" || item?.mode == "UPI" || item?.mode == "Cheque" || item?.mode == "RTGS")
      ) {
        paidAmount += +(
          +(item?.amount || 0) ||
          +(item?.MetalCashTotalAmount || 0) ||
          0
        );
        // if (item?.MetalCashTotalAmount) {
        //   setValue(
        //     "TotalTaxableAmount",
        //     (
        //       +(TotalTaxableAmount || 0) - +(item?.MetalCashTotalAmount || 0)
        //     )?.toFixed(3)
        //   );
        // }
      }
      if ((item?.status == "received" || item?.status == "paid") && item?.mode == "Cash to Metal") {
        paidMetal += +(item?.MetalFinePaid || 0);
      }
    });

    if (+TotalFineMetal) {
      balanceMetal = +(TotalFineMetal || 0) - +(paidMetal || 0);
    } else {
      balanceMetal = 0 - +(paidMetal || 0);
    }

    setValue("TotalPaidMetal", (+(paidMetal || 0))?.toFixed(3));
    setValue("TotalBalanceMetal", (+(balanceMetal || 0))?.toFixed(3));
    setValue("TotalAdvanceAmount", (+(advanceAmount || 0))?.toFixed(3));
    setValue("TotalPaidAmount", (+(paidAmount || 0))?.toFixed(3));
  }, [paymentTypes, TotalFineMetal]);

  useEffect(() => {
    setValue(
      "TotalBalanceAmount",
      (+(TotalBillAmount || 0) - +(TotalPaidAmount || 0))?.toFixed(3)
    );
  }, [TotalBillAmount, TotalPaidAmount]);

  useEffect(() => {
    vebdorListRefetch();
  }, [VendorName?.value]);

  useEffect(() => {
    const vendor = vendorlist?.find((vendr) => vendr?.Id == VendorName?.value);
    if (vendor?.Id) {
      setValue("TotalFineGold", vendor?.FineGold);
      setValue("TotalFineSilver", vendor?.FineSilver);
      setValue("advanceamount", vendor?.AdvanceAmt);
      setValue("balanceamount", vendor?.BalanceAmt);
    }
  }, [VendorName?.value, vendorlist]);

  const reloadData = () => {
    setShowModal(false); // Close the modal
    // loadData();
  };

  // const addSku = (data) => {
  //   console.log(data);
  //   setValue("skus", [
  //     ...skus,
  //     {
  //       id: editStatus ? data?.id : Date.now(),
  //       ...data,
  //     },
  //   ]);
  //   setIsSummaryOpen(true);
  // };


  const addSku = (data, fromDropdown, bulk = false) => {
    console.log(data);
    if (!bulk) {
      if (!customerName?.value) {
        toast.error("Please Select Customer", {
          position: "top-center",
          duration: 3000,
        });
        return;
      }
      let result = [];
      let customerTounch = [];
      if (fromDropdown) {
        result = CustomerTounchList?.filter((item) => {
          if (
            item?.CustomerId == customerName?.value &&
            item?.StockKeepingUnit == data?.SKU &&
            item?.CategoryId == data?.CategoryId &&
            item?.ProductId == data?.ProductId &&
            item?.DesignId == data?.DesignId &&
            item?.PurityId == data?.PurityId
          ) {
            return item;
          }
        });
      }
      if (fromDropdown) {
        customerTounch = CustomerTounchList?.filter((item) => {
          if (item?.CustomerId == customerName?.value) {
            return item;
          }
        });
      }

      const res = fromDropdown
        ? rateList?.length &&
          rateList?.filter((item) => {
            if (
              item?.PurityId == data?.PurityId &&
              item?.CategoryId == data?.CategoryId
            ) {
              return item;
            }
          })?.length
          ? {
              ...data,
              MetalRate: +(
                rateList?.filter(
                  (item) =>
                    item?.PurityId == data?.PurityId &&
                    item?.CategoryId == data?.CategoryId
                )[0]?.Rate || 0
              ),
              MakingPercentage: result?.length
                ? result[0]?.MakingPercentage
                : data?.MakingPercentage,
              FinePercent: result?.length
                ? result[0]?.FinePercentage
                : data?.FinePercentage,
              MakingFixedAmt: result?.length
                ? result[0]?.MakingFixedAmt
                : data?.MakingFixedAmt,
              MakingPerGram: result?.length
                ? result[0]?.MakingPerGram
                : data?.MakingPerGram,
              MakingFixedWastage: result?.length
                ? result[0]?.MakingFixedWastage
                : data?.MakingFixedWastage,
            }
          : {
              ...data,
              MakingPercentage: result?.length
                ? result[0]?.MakingPercentage
                : data?.MakingPercentage,
              FinePercent: result?.length
                ? result[0]?.FinePercentage
                : data?.FinePercentage,
              MakingFixedAmt: result?.length
                ? result[0]?.MakingFixedAmt
                : data?.MakingFixedAmt,
              MakingPerGram: result?.length
                ? result[0]?.MakingPerGram
                : data?.MakingPerGram,
              MakingFixedWastage: result?.length
                ? result[0]?.MakingFixedWastage
                : data?.MakingFixedWastage,
            }
        : convertInInvoiceWholeSaleFormat(data);

      const sku = fromDropdown ? calculateAmount(res, customerTounch) : res;
      console.log(sku);
      const a = [
        {
          TIDNumber: "E2801191A503006148688932",
          ItemCode: "DGO387",
          Id: 3692,
          ProductTitle: null,
          HSNCode: "7113",
          Description: "",
          ProductCode: null,
          MetalName: null,
          CategoryId: 1,
          ProductId: 1,
          DesignId: 1,
          PurityId: 1,
          Colour: null,
          Size: null,
          GrossWt: "20.000",
          NetWt: "20.000",
          WeightCategory: null,
          CollectionName: null,
          OccassionName: null,
          Gender: "",
          MakingFixedAmt: "0.000",
          MakingPerGram: "0.000",
          MakingFixedWastage: "0.000",
          TotalStoneWeight: "0.000",
          MakingPercentage: "0.000",
          TotalStoneAmount: "0.000",
          TotalDiamondPieces: null,
          TotalStonePieces: "",
          TotalDiamondWeight: "0",
          TotalDiamondAmount: "0",
          Featured: null,
          Pieces: "",
          HallmarkAmount: null,
          HUIDCode: null,
          MRP: "0.000",
          VendorId: 1,
          BoxId: 0,
          RFIDCode: "CZ3585",
          Images: null,
          BlackBeads: null,
          Height: null,
          Width: null,
          OrderedItemId: null,
          CuttingGrossWt: null,
          CuttingNetWt: null,
          MetalRate: null,
          LotNumber: null,
          DeptId: 0,
          Margin: null,
          PurchaseCost: null,
          BranchName: "Home",
          BoxName: null,
          EstimatedDays: null,
          Rating: null,
          SKU: null,
          OfferPrice: null,
          SKUId: 0,
          CompanyId: 0,
          Ranking: null,
          CounterId: 0,
          BranchId: 1,
          Status: "Active",
          ClientCode: "LS000093",
          EmployeeId: 0,
          UpdatedFrom: null,
          MetalId: 1,
          WarehouseId: 0,
          TaxId: 0,
          TaxPercentage: null,
          OtherWeight: null,
          PouchWeight: null,
          PurityName: null,
          DiamondSize: "",
          DiamondWeight: "",
          DiamondPurchaseRate: null,
          DiamondSellRate: "",
          DiamondClarity: "",
          DiamondColour: "",
          DiamondShape: "",
          DiamondCut: "",
          DiamondSettingType: "",
          DiamondCertificate: "",
          DiamondPieces: "",
          DiamondPurchaseAmount: null,
          DiamondSellAmount: null,
          DiamondDescription: "",
          ClipWeight: "0.000",
          ClipQuantity: "0",
          TagWeight: null,
          FindingWeight: null,
          LanyardWeight: null,
          WastagePercent: null,
          PacketId: 0,
          CreatedOn: "2025-03-28T12:54:20.164327",
          LastUpdated: "2025-03-28T12:54:20.1643258",
          StatusType: true,
          SalesmanId: 0,
          CollectionId: 0,
          CollectionNameSKU: null,
          PackingWeight: 0,
          TotalWeight: "20.000",
          StoneColour: "",
          StoneShape: "",
          StoneSize: "",
          StoneRatePerPiece: null,
          StoneWeightType: null,
          StoneCertificate: "",
          StoneSettingType: "",
          DiamondCategory: null,
          StoneCategory: null,
          Qty: 1,
          MetalAmount: "0.000",
          TotalItemAmount: "0.000",
          TotalMakingAmount: 0,
          FineWt: 0,
          WastageWt: 0,
          FineWastageWt: 0,
          StonePieces: "",
        },
        {
          TIDNumber: "E2801191A503006148684651",
          ItemCode: "DGO388",
          Id: 3693,
          ProductTitle: null,
          HSNCode: "7113",
          Description: "",
          ProductCode: null,
          MetalName: null,
          CategoryId: 1,
          ProductId: 1,
          DesignId: 1,
          PurityId: 1,
          Colour: null,
          Size: null,
          GrossWt: "20.000",
          NetWt: "20.000",
          WeightCategory: null,
          CollectionName: null,
          OccassionName: null,
          Gender: "",
          MakingFixedAmt: "0.000",
          MakingPerGram: "0.000",
          MakingFixedWastage: "0.000",
          TotalStoneWeight: "0.000",
          MakingPercentage: "0.000",
          TotalStoneAmount: "0.000",
          TotalDiamondPieces: null,
          TotalStonePieces: "",
          TotalDiamondWeight: "0",
          TotalDiamondAmount: "0",
          Featured: null,
          Pieces: "",
          HallmarkAmount: null,
          HUIDCode: null,
          MRP: "0.000",
          VendorId: 1075,
          BoxId: 0,
          RFIDCode: "CZ3549",
          Images: null,
          BlackBeads: null,
          Height: null,
          Width: null,
          OrderedItemId: null,
          CuttingGrossWt: null,
          CuttingNetWt: null,
          MetalRate: null,
          LotNumber: null,
          DeptId: 0,
          Margin: null,
          PurchaseCost: null,
          BranchName: "Home",
          BoxName: null,
          EstimatedDays: null,
          Rating: null,
          SKU: null,
          OfferPrice: null,
          SKUId: 0,
          CompanyId: 0,
          Ranking: null,
          CounterId: 0,
          BranchId: 1,
          Status: "Active",
          ClientCode: "LS000093",
          EmployeeId: 0,
          UpdatedFrom: null,
          MetalId: 1,
          WarehouseId: 0,
          TaxId: 0,
          TaxPercentage: null,
          OtherWeight: null,
          PouchWeight: null,
          PurityName: null,
          DiamondSize: "",
          DiamondWeight: "",
          DiamondPurchaseRate: null,
          DiamondSellRate: "",
          DiamondClarity: "",
          DiamondColour: "",
          DiamondShape: "",
          DiamondCut: "",
          DiamondSettingType: "",
          DiamondCertificate: "",
          DiamondPieces: "",
          DiamondPurchaseAmount: null,
          DiamondSellAmount: null,
          DiamondDescription: "",
          ClipWeight: "0.000",
          ClipQuantity: "0",
          TagWeight: null,
          FindingWeight: null,
          LanyardWeight: null,
          WastagePercent: null,
          PacketId: 0,
          CreatedOn: "2025-03-28T12:55:02.4959899",
          LastUpdated: "2025-03-28T12:55:02.4959892",
          StatusType: true,
          SalesmanId: 0,
          CollectionId: 0,
          CollectionNameSKU: null,
          PackingWeight: 0,
          TotalWeight: "20.000",
          StoneColour: "",
          StoneShape: "",
          StoneSize: "",
          StoneRatePerPiece: null,
          StoneWeightType: null,
          StoneCertificate: "",
          StoneSettingType: "",
          DiamondCategory: null,
          StoneCategory: null,
          Qty: 1,
          MetalAmount: "0.000",
          TotalItemAmount: "0.000",
          TotalMakingAmount: 0,
          FineWt: 0,
          WastageWt: 0,
          FineWastageWt: 0,
          StonePieces: "",
        },
      ];
      setValue("skus", [...skus, sku]);
      setIsSummaryOpen(true);
    } else {
      const response = [...data];
      const bulkData = [];
      response?.forEach((data) => {
        if (!customerName?.value) {
          toast.error("Please Select Customer", {
            position: "top-center",
            duration: 3000,
          });
          return;
        }
        let result = [];
        let customerTounch = [];
        if (fromDropdown) {
          result = CustomerTounchList?.filter((item) => {
            if (
              item?.CustomerId == customerName?.value &&
              item?.StockKeepingUnit == data?.SKU &&
              item?.CategoryId == data?.CategoryId &&
              item?.ProductId == data?.ProductId &&
              item?.DesignId == data?.DesignId &&
              item?.PurityId == data?.PurityId
            ) {
              return item;
            }
          });
        }
        if (fromDropdown) {
          customerTounch = CustomerTounchList?.filter((item) => {
            if (item?.CustomerId == customerName?.value) {
              return item;
            }
          });
        }

        const res = fromDropdown
          ? rateList?.length &&
            rateList?.filter((item) => {
              if (
                item?.PurityId == data?.PurityId &&
                item?.CategoryId == data?.CategoryId
              ) {
                return item;
              }
            })?.length
            ? {
                ...data,
                MetalRate: +(
                  rateList?.filter(
                    (item) =>
                      item?.PurityId == data?.PurityId &&
                      item?.CategoryId == data?.CategoryId
                  )[0]?.Rate || 0
                ),
                MakingPercentage: result?.length
                  ? result[0]?.MakingPercentage
                  : data?.MakingPercentage,
                FinePercent: result?.length
                  ? result[0]?.FinePercentage
                  : data?.FinePercentage,
                MakingFixedAmt: result?.length
                  ? result[0]?.MakingFixedAmt
                  : data?.MakingFixedAmt,
                MakingPerGram: result?.length
                  ? result[0]?.MakingPerGram
                  : data?.MakingPerGram,
                MakingFixedWastage: result?.length
                  ? result[0]?.MakingFixedWastage
                  : data?.MakingFixedWastage,
              }
            : {
                ...data,
                MakingPercentage: result?.length
                  ? result[0]?.MakingPercentage
                  : data?.MakingPercentage,
                FinePercent: result?.length
                  ? result[0]?.FinePercentage
                  : data?.FinePercentage,
                MakingFixedAmt: result?.length
                  ? result[0]?.MakingFixedAmt
                  : data?.MakingFixedAmt,
                MakingPerGram: result?.length
                  ? result[0]?.MakingPerGram
                  : data?.MakingPerGram,
                MakingFixedWastage: result?.length
                  ? result[0]?.MakingFixedWastage
                  : data?.MakingFixedWastage,
              }
          : convertInInvoiceWholeSaleFormat(data);

        const sku = fromDropdown ? calculateAmount(res, customerTounch) : res;
        console.log(sku);
        bulkData.push(sku);
      });
      setValue("skus", [...skus, ...bulkData]);
      setIsSummaryOpen(true);
    }
  };

  const updateSku = (data) => {
    setValue(
      "skus",
      skus.map((sku) => (sku.id === data.id ? data : sku)) // Replace only the matching SKU
    );
    setEditValues();
    setEdit(false);
    setIsSummaryOpen(true);
  };
  const addPaymentMode = (data) => {
    setValue("paymentTypes", [
      ...paymentTypes,
      {
        // id: editStatus ? data?.id : Date.now(),
        ...data,
      },
    ]);
  };

  const onSubmit = async (data) => {
    if (!skus.length) {
      toast.error("Atleast one item needed");
      return;
    }
    console.log("submiting",data)

    const formData = getPurchaseEntryFormData({
      data,
      selectedFiles: [],
      vendorlist,
      clientCode,
      invoiceDate,
      CompanyId,
      CounterId,
      BranchId,
      EmployeeId,
    });
    console.log(formData)

   
    // generatePurchaseInvoice(data)
   
   
      setPurchaseCreateLoading(true);
    if (editStatus) {
      formData.append("Id", data?.Id);
      try {
        const response = await fetch(a166, {
          method: "POST",
          body: formData,
        });
        const jsondata = await response.json();
        console.log(jsondata);
        if (jsondata?.Id) {
          await sendProductData(jsondata?.Id, data);
        }
      } catch (error) {
        console.log(error);
        setPurchaseCreateLoading(false);
        toast.error(error?.message || "Failed to update purchase information.");
      }
    } else {
      try {
        const response = await fetch(a154, {
          method: "POST",
          body: formData,
        });
        const jsondata = await response.json();
        if (jsondata?.Id) {
          await sendProductData(jsondata?.Id, data);
        }
      } catch (error) {
        console.log(error);
        setPurchaseCreateLoading(false);
      }
    }
  };

  

  async function sendProductData(rcvdId, data) {
    

   
  
    
    try {
      const additionalInfo = {
        clientCode,
        EmployeeId,
        CompanyId,
        BranchId,
        CounterId,
        labelFormat,
      };
      const payload = editStatus
        ? purchaseEntryEditJSon({ rcvdId, data, additionalInfo, vendorlist })
        : purchaseEntryJson({ rcvdId, data, additionalInfo, vendorlist });
      const response = await fetch(a155, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const paymentResponse = await fetch(editStatus ? a167 : a156, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload[0]?.Payments),
      });

      const currentCategory = data?.skus[0]?.CategoryId?.value;
      let FineGold = 0;
      let FineSilver = 0;
      
      if (goldCategoryIds.includes(+(currentCategory || 0))) {
        // FineGold += data?.
        FineGold += +(data?.TotalBalanceMetal || 0);
      }
      if (silverCategoryIds.includes(+(currentCategory || 0))) {
        // FineGold += data?.
        FineSilver += +(data?.TotalBalanceMetal || 0);
      }
      const vendor = vendorlist?.find(
        (vndr) => vndr?.Id == data?.VendorName?.value
      );
      const formData = {
        ...vendor,
        BalanceAmt:
          "" +
          (
            +(vendor?.BalanceAmt || 0) + +(data?.TotalBalanceAmount || 0)
          )?.toFixed(3),
        AdvanceAmt:
          "" +
          (
            +(vendor?.AdvanceAmt || 0) + +(data?.TotalAdvanceAmount || 0)
          )?.toFixed(3),
        ...(goldCategoryIds.includes(+(currentCategory || 0))
          ? { FineGold: "" + (+(vendor?.FineGold || 0) + FineGold)?.toFixed(3) }
          : {}),
        ...(silverCategoryIds.includes(+(currentCategory || 0))
          ? {
              FineSilver:
                "" + (+(vendor?.FineSilver || 0) + FineSilver)?.toFixed(3),
            }
          : {}),
      };

      // ---- updating vendor detail -----
      const updateVendorDetail = await fetch(a742, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      toast.success(
        `Purchase entry has been ${
          editStatus ? "updated" : "created"
        } successfully.`
      );
      // generatePurchaseInvoice(data)
      GeneratePurchase(data?.skus, data?.VendorName, data);
     

      if (editStatus) {
        navigate("/purchase_entries_list");
      } else {
        RDPurchaseRefetch();
        setTimeout(() => {
          navigate("/purchase_entry_new");
        }, 2000);
      }
    } catch (error) {
      console.log("error", error);
      toast.success(error?.message);
    } finally {
      setPurchaseCreateLoading(false);
    }
  }

  const handleReset = () => {
    if (editStatus && id) {
      navigate(`/edit_purchase_entry_new/${id}`);
    } else {
      RDPurchaseRefetch();
      navigate("/purchase_entry_new");
    }
  };

  const vendorOptions = [
    { value: "vendor1", label: "Vendor 1" },
    { value: "vendor2", label: "Vendor 2" },
  ]

    useEffect(() => {
      RefetchCustomerList();
    }, [customerName?.value]);
 
  
  useEffect(() => {
    const customer = customerList?.length
      ? customerList?.find((customr) => customr?.Id == customerName?.value)
      : {};
    if (customer?.Id) {
      setValue("TotalFineGold", customer?.FineGold);
      setValue("Mobile", customer?.Mobile);
      setValue("advanceamount", customer?.AdvanceAmount);
      setValue("balanceamount", customer?.BalanceAmount);
    }
  }, [customerName?.value, customerList]);

  console.log(itemfields);
  console.log(customerList);

  return (
    <>
      <div>
        <AdminHeading />
        <>
          <div>
            <ErrorModal
              isOpen={showModal}
              onRequestClose={() => {
                setShowModal(false); // Close the modal
                navigate("/adminhome"); // Redirect to /adminhome
              }}
              onReload={reloadData} // Pass reload function
              message={errorMessage}
            />

            <div className="adminMainBodyBox">
              {showError ? (
                <AlertMessage message={messageToShow} type={messageType} />
              ) : null}
            </div>
          </div>
        </>
        {/* )} */}

        <AdminBreadCrump
          title={'Repair Entry'}
          companyName={"Loyalstring"}
          module={"Transactions"}
          page={'Repair Entry'}
        />
      </div>

      <form className={styles.mainbox}>
        {/*basic detail section */}
        <div className={styles.linesection} style={{ padding: "0px 20px" }}>
          <div className={styles.infoline}>
            <div className={styles.box} style={{display:"flex",alignItems:'center',justifyContent:'flex-start', gap: 3}}>
              <label>Repair No.</label>
              <strong style={{ color: "blue", fontSize: "14px" }}>
                1234
              </strong>
            </div>
            <div
              className={styles.dateSection}
              // style={{ alignItems: "center" ,justifyContent:'end'}}
            >
              {/* <div style={{ display: "flex",gap:"2px" }}>
                Lot No.{" "}
                {RDPurchaseListIsLoading ? (
                  <Spinner />
                ) : (
                  <strong style={{ color: "blue" }}>1234</strong>
                )}
              </div> */}
              <div style={{ position: "relative", display: "inline-block" }}>
                <input
                  id="invoiceDate"
                  type="date"
                  {...register("invoiceDate")}
                  style={{
                    width: "100%",
                    padding: "5px 10px",
                    paddingRight: "30px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    height: '35px'
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* top section */}
        <div className={styles.linesection}>
          <div className={styles.container}>
            {itemfields
              ?.filter((field) => field?.place === "top" && field.IsVisible)
              .sort((a, b) => a.priority - b.priority)
              .map((field, index) => (
                <div className={styles.box}>
                  <label>
                    {field.label}
                    {field?.mandatory && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "2px",
                    }}
                  >
                    <div style={{ flex: "6" }}>
                      {field.type === "inputselect" ? (
                        <input
                          type="text"
                          name={field.key}
                          placeholder={`${field.label}`}
                          disabled={field.visibility === "ReadOnly"}
                          {...register(field.key, {
                            required:
                              field?.mandatory &&
                              field.visibility !== "ReadOnly" &&
                              `${field.label} is required`,
                          })}
                          list="skuList"
                          autoComplete="off"
                          style={{
                            border: "1px solid #ddd",
                            position: "relative",
                          width: "100%",
                          }}
                        />
                      ) : // SKU Input with datalist

                      field.type === "dropdown" ||
                        field.type === "searchDropdown" ? (
                        <Controller
                          name={field.key}
                          control={control}
                          rules={{
                            required:
                              field?.mandatory &&
                              field.visibility !== "ReadOnly" &&
                              `${field.label} is required`,
                          }}
                          render={({
                            field: controllerField,
                            // fieldState: { error },
                          }) => (
                            <Select
                              {...controllerField}
                              options={
                                field.key === "customerName"
                                  ? Array.isArray(customerList)
                                    ? customerList?.map((vendor) => ({
                                        value: vendor?.Id,
                                        label: vendor?.FirstName,
                                        //  + vendor?.LastName
                                      }))
                                    : []
                                  : []
                              }
                              isDisabled={field.visibility === "ReadOnly"}
                              isSearchable={field.type === "searchDropdown"}
                              placeholder="-- select --"
                              styles={selectStyle}
                            />
                          )}
                        />
                      ) : field.type === "number" || field.type === "text" ? (
                        // Number input field
                        <input
                          name={field.key}
                          type={field.type}
                          placeholder={`${field.label}`}
                          {...register(field.key, {
                            required:
                              field.visibility !== "ReadOnly" &&
                              field?.mandatory &&
                              `${field.label} is required`,
                            pattern:
                              field.type === "number" ? /^\d+$/ : undefined,
                          })}
                          style={{ border: "1px solid #ddd", height: "35px" , width: '100%'}}
                          disabled={field.visibility === "ReadOnly"}
                        />
                      ) : null}
                    </div>
                    {field?.key == "customerName" && (
                      <button
                        title="Add Customer"
                        type="button"
                        onClick={() => navigate("/add_customer_new")}
                        style={{ background: "#627282", flex: "1" }}
                      >
                        +
                      </button>
                    )}
                  </div>
                  {errors[field.key] && (
                    <span className={styles.fielderror}>
                      {errors[field.key].message}
                    </span>
                  )}
                </div>
              ))}
          </div>
        </div>
        
        {isSummaryOpen ? (
          <div className={styles.summarySection}>
            <>
              {skus[0]?.CategoryId?.value != looseStoneId &&
              skus[0]?.CategoryId?.value != looseDiamondId ? (
                <Summary
                  skus={skus}
                  setIsSummaryOpen={setIsSummaryOpen}
                  setValue={setValue}
                  setEditValues={setEditValues}
                  setEdit={setEdit}
                  TotalFineMetal={TotalFineMetal}
                />
              ) : skus[0]?.CategoryId?.value == looseStoneId ? (
                <StoneSummary
                  skus={skus}
                  setIsSummaryOpen={setIsSummaryOpen}
                  setValue={setValue}
                  setEditValues={setEditValues}
                  setEdit={setEdit}
                  TotalFineMetal={TotalFineMetal}
                />
              ) : skus[0]?.CategoryId?.value == looseDiamondId ? (
                <DiamondSummary
                  skus={skus}
                  setIsSummaryOpen={setIsSummaryOpen}
                  setValue={setValue}
                  setEditValues={setEditValues}
                  setEdit={setEdit}
                  TotalFineMetal={TotalFineMetal}
                />
              ) : (
                ""
              )}
            </>
          </div>
        ) : (
          <>
            {/* middle section */}
            <SkuFormRepair
              skus={skus}
              isInvoiceEntry={false}
              // itemfields={fields}
              itemfields={itemfields.filter(
                (field) =>
                  field.place === 'middle' &&
                  String(field.visibility).toLowerCase() !== 'hidden'
              )}
              editValues={editValues}
              edit={edit}
              updateSku={updateSku}
              addSku={addSku}
              isSummaryOpen={isSummaryOpen}
              setIsSummaryOpen={setIsSummaryOpen}
              apifields={apifields}
              setItemfields={setItemfields}
              setCategory={setCategory}
              VendorName={VendorName}
              vendorTounchList={vendorTounchList}
              invoiceNumber={invoiceNumber}
              customerName={customerName}
            />
          </>
        )}

        {/* bottom section */}
        <div className={styles.linesection}>
          {/* calculations section */}
          <div className={styles.calculation}>
            {/* Left Section */}

            <div className={styles.calculationleft}>
              <PaymentModeFormRepair
                addPaymentMode={addPaymentMode}
                invoiceNumber={invoiceNumber}
                AdvanceAmount={AdvanceAmount}
                skus={skus}
                componentType={"Purchase"}
                gstCheckbox={gstCheckbox}
              />

              <div className={styles.tableContainer}>
                <PaymentsEntryTableRepair
                  styles={styles}
                  paymentTypes={paymentTypes}
                  setValue={setValue}
                />
              </div>
            </div>

            {/* Right Section */}

            <AmountSectionRepair styles={styles} register={register} />
          </div>
          {/* {errors.status && (
            <p className={styles.error}>{errors.status.message}</p>
          )} */}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "10px",
          }}
        >
          <button
            style={{
              fontSize: "12px", // Smaller font size for responsiveness
              backgroundColor: "#0077d4",
              padding: "4px 6px", // Adjusted padding
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flex: "1 1 auto", // Allows buttons to shrink proportionally
              minWidth: "100px", // Minimum button width
              maxWidth: "150px", // Prevents overly wide buttons
            }}
            type="button"
            onClick={handleSubmit(onSubmit)}
            disabled={purchaseCreateLoading}
          >
            {purchaseCreateLoading ? <Spinner /> : <Check size={20} />}{" "}
            {/* Adjusted icon size */}
            Save
          </button>

          <button
            type="button"
            onClick={handleReset}
            style={{
              background: "#fff",
              fontSize: "12px", // Smaller font size for responsiveness
              color: "#0077D4",
              padding: "4px 6px", // Adjusted padding
              display: "flex",
              alignItems: "center",
              gap: "5px",
              border: "1px solid #0077D4",
              flex: "1 1 auto",
              minWidth: "100px",
              maxWidth: "150px",
            }}
            disabled={purchaseCreateLoading}
          >
            <Refresh size={20} /> {/* Adjusted icon size */}
            Reset
          </button>

          <button
            onClick={() => {
              navigate(`/purchase_entries_list`);
            }}
            type="button"
            style={{
              fontSize: "12px", // Smaller font size for responsiveness
              backgroundColor: "#0077d4",
              padding: "4px 6px", // Adjusted padding
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flex: "1 1 auto",
              minWidth: "100px",
              maxWidth: "150px",
            }}
            disabled={purchaseCreateLoading}
          >
            <Icon style={{ fontSize: "20px" }} icon="solar:list-bold" />{" "}
            {/* Adjusted icon size */}
            Purchase List
          </button>
        </div>
      </form>
    </>
  );
};

export default AdminRepairEntryNew;
